import TaskType from '../Models/TaskType';
import DataGridRequest from './DataGridRequest';
export class ReplyToAddressRequest extends DataGridRequest<TaskType> {
    Url = 'reply_to_addresses/api';
}
